<template>
  <div id="workBench">
    <EmitComponent :allComponentList="allComponentList" @emitComponent="addComponent" />
    <!-- bootstrap toggle button -->
    <div class="form-check form-switch ml-2">
      <input class="form-check-input" type="checkbox" id="flexSwitchCheckChecked" v-model="connected">
      <label class="form-check-label" for="flexSwitchCheckChecked">Connected Components</label>
    </div>
    <div ref="root_node" id="branchPaint"></div>
  </div>
</template>

<script>
import { Graph } from '@antv/x6';
import Vue from 'vue';
import insertCss from 'insert-css';
import Home from './PageHome.vue';
import AuthorView from './PageAuthorView.vue';
import ReadingView from './PageReadingView.vue';
import MobileView from './PageMobileView.vue';
import EmitComponent from '../components/EmitComponent.vue';
import BookLibrary from '../components/BookLibrary.vue';
import Recentevents from '../components/Recentevents.vue';
import MiniExplore from '../components/MiniExplore.vue';
import Information from '../components/Information.vue';
import Thoughtverse from '../components/Thoughtverse.vue';
import Thoughtversealt from '../components/Thoughtversealt.vue';
import Thoughtversecontrols from '../components/Thoughtversecontrols.vue';
import GutenbergLibrary from '../components/GutenbergLibrary.vue';
import LoaderSemantic from '../components/LoaderSemantic.vue';
import NotesLibrary from '../components/NotesLibrary.vue';
import ThreeDModelViewer from '../components/ThreeDModelViewer.vue';
import Compare from '../components/Compare.vue';
import Dendograph from '../components/Dendograph.vue';
import WikiDataCard from '../components/WikiDataCard.vue';
import IframeComponent from '../components/IframeComponent.vue';
import Snippet from '../components/Snippet.vue';
import SkillGraph from '../components/SkillGraph.vue';
import VisitedGraphVR from '../components/VisitedGraphVR.vue';
import VisitedGraphAlt from '../components/VisitedGraphAlt.vue';
import ThoughtMarkdown from '../components/ThoughtMarkdown.vue';
import Twitterfeed from '../components/Twitterfeed.vue';
import LinkedThoughts from '../components/LinkedThoughts.vue';
import GraphExplore from '../components/GraphExplore.vue';
import LayoutController from '../components/LayoutController.vue';
import GraphControls from '../components/GraphControls.vue';
import RecentActivity from '../components/RecentActivity.vue';
import GraphLibrary from '../components/GraphLibrary.vue';
import Editor from '../components/Editor.vue';
import Detail from '../components/Detail.vue';
import TreasureMarker from '../components/TreasureMarker.vue';
import ThoughtMap from '../components/ThoughtMap.vue';
import QuestLibrary from '../components/QuestLibrary.vue';
// eslint-disable-next-line
import router from '../router';
// eslint-disable-next-line
import store from '../store';
// eslint-disable-next-line
import i18n from '../i18n';
import canvasConfig from '../plugins/canvasConfig';

export default {
  name: 'PageCanvas',

  metaInfo: {
    title: 'Canvas View',
  },

  components: {
    EmitComponent,
  },

  computed: {
    allComponentList() {
      return this.componentsOptions.map((item) => item.name);
    },
  },

  data() {
    return {
      connected: true,
      componentsOptions: [
        {
          name: 'Home',
          component: Home,
          options: {
            title: 'Home Page',
            description: 'This is the home page',
          },
        },
        {
          name: 'AuthorView',
          component: AuthorView,
          options: {
            title: 'Second View',
            description: 'This is the second view',
          },
        },
        {
          name: 'ReadingView',
          component: ReadingView,
          options: {
            title: 'Third View',
            description: 'This is the third view',
          },
        },
        {
          name: 'MobileView',
          component: MobileView,
          options: {
            title: 'Mobile View',
            description: 'This is the mobile view',
          },
        },
        {
          name: 'NotesLibrary',
          component: NotesLibrary,
          options: {
            title: 'Noted Items',
            description: 'View all your notes',
          },
        },
        {
          name: 'TreasureMarker',
          component: TreasureMarker,
          options: {
            title: 'TreasureMarker',
            description: 'TreasureMarker',
          },
        },
        {
          name: 'QuestLibrary',
          component: QuestLibrary,
          options: {
            title: 'Quest List',
            description: 'View all your Quests',
          },
        },
        {
          name: 'ThoughtMap',
          component: ThoughtMap,
          options: {
            title: 'ThoughtMap',
            description: 'ThoughtMap',
          },
        },
        {
          name: 'Detail',
          component: Detail,
          options: {
            title: 'Node operations',
            description: 'Edit and view your nodes',
          },
        },
        {
          name: 'Editor',
          component: Editor,
          options: {
            title: 'Editor',
            description: 'Edit you notes',
          },
        },
        {
          name: 'GraphLibrary',
          component: GraphLibrary,
          options: {
            title: 'Saved Graph',
            description: 'View all your graph',
          },
        },
        {
          name: 'LinkedThoughts',
          component: LinkedThoughts,
          options: {
            title: 'LinkedThoughts',
            description: 'G6 Graph Wikidata',
          },
        },
        {
          name: 'GraphControls',
          component: GraphControls,
          options: {
            title: 'Universal controller',
            description: 'control force graph with this component',
          },
        },
        {
          name: 'LayoutController',
          component: LayoutController,
          options: {
            title: 'Layout Controller',
            description: 'Edit your layout with this config',
          },
        },
        {
          name: 'WikiDataCard',
          component: WikiDataCard,
          options: {
            title: 'WikiDataCard',
            description: 'Get information from wiki data',
          },
        },
        {
          name: 'RecentActivity',
          component: RecentActivity,
          options: {
            title: 'RecentActivity',
            description: 'Gist of what people are doing',
          },
        },
        {
          name: 'Snippet',
          component: Snippet,
          options: {
            title: 'Snippet',
            description: 'Get categorised data from Wiki data',
          },
        },
        {
          name: 'Twitterfeed',
          component: Twitterfeed,
          options: {
            title: 'Twitterfeed',
            description: 'Related tweets from Twitter',
          },
        },
        {
          name: 'Compare',
          component: Compare,
          options: {
            title: 'Compare Widget',
            description: 'Compare your Widget',
          },
        },
        {
          name: 'Dendograph',
          component: Dendograph,
          options: {
            title: 'DendroGraph',
            description: 'DendroGram Visualization',
          },
        },
        {
          name: 'ThreeDModelViewer',
          component: ThreeDModelViewer,
          options: {
            title: '3D Viewer',
            description: 'View in 3D',
          },
        },
        {
          name: 'Recentevents',
          component: Recentevents,
          options: {
            title: 'Events',
            description: 'View all your events',
          },
        },
        {
          name: 'SkillGraph',
          component: SkillGraph,
          options: {
            title: 'Skills',
            description: 'View all your skills',
          },
        },
        {
          name: 'BookLibrary',
          component: BookLibrary,
          options: {
            title: 'Books',
            description: 'View all your books',
          },
        },
        {
          name: 'MiniExplore',
          component: MiniExplore,
          options: {
            title: 'MiniExplore',
            description: 'Explore your idea',
          },
        },
        {
          name: 'Information',
          component: Information,
          options: {
            title: 'Information',
            description: 'Short Information for Explore',
          },
        },
        {
          name: 'Thoughtverse',
          component: Thoughtverse,
          options: {
            title: 'Force Graph',
            description: 'Immersive Exploration',
          },
        },
        {
          name: 'Thoughtversealt',
          component: Thoughtversealt,
          options: {
            title: 'Force Graph',
            description: 'Immersive Exploration in AR',
          },
        },
        {
          name: 'Thoughtversecontrols',
          component: Thoughtversecontrols,
          options: {
            title: 'Force Graph',
            description: 'Graph Controls',
          },
        },

        {
          name: 'LoaderSemantic',
          component: LoaderSemantic,
          options: {
            title: 'Loader',
            description: 'View all async calls',
          },
        },
        {
          name: 'GutenbergLibrary',
          component: GutenbergLibrary,
          options: {
            title: 'Gutenberg',
            description: 'View books from Gutenberg',
          },
        },
        {
          name: 'IframeComponent',
          component: IframeComponent,
          options: {
            title: 'Netherworld',
            description: 'Dive into another world',
          },
        },
        {
          name: 'VisitedGraphVR',
          component: VisitedGraphVR,
          options: {
            title: 'VisitedGraphVR',
            description: 'All visited Links in the last Day',
          },
        },
        {
          name: 'VisitedGraphAlt',
          component: VisitedGraphAlt,
          options: {
            title: 'VisitedGraphAlt',
            description: 'All visited Links in the last Day 3D',
          },
        },
        {
          name: 'ThoughtMarkdown',
          component: ThoughtMarkdown,
          options: {
            title: 'ThoughtMarkdown',
            description: 'Autogenerated Markdown from events',
          },
        },
        {
          name: 'GraphExplore',
          component: GraphExplore,
          options: {
            title: 'GraphExplore',
            description: 'GraphExplore',
          },
        },
      ],
    };
  },
  async mounted() {
    await this.buildMyPage();
    insertCss(`
      .nodeEl {
        padding: 10px;
        margin: 10px;
        background: #fff;
        min-width: 400px;
        min-height: 200px;
        border: 1px solid #000;
        border-radius: 10px;
      }
    `);
    // Shorcut Keys
    this.bindKeys();
    // edit label of an edge
    this.graph.on('edge:dblclick', this.addEdgeLabel);
  },

  methods: {
    // add labels to your edge
    addEdgeLabel({ cell, e }) {
      cell.addTools({
        name: 'edge-editor',
        args: {
          event: e,
        },
      });
    },

    disableInt() {
      this.graph.disablePanning();
      this.graph.lockScroller();
      this.graph.disableMouseWheel();
    },

    bindKeys() {
      // delete
      this.graph.bindKey('ctrl+backspace', () => {
        const cells = this.graph.getSelectedCells();
        if (cells.length) {
          this.graph.removeCells(cells);
        }
      });

      // to undo things
      this.graph.bindKey(['meta+z', 'ctrl+z'], () => {
        if (this.graph.history.canUndo()) {
          this.graph.history.undo();
        }
        return false;
      });

      // to redo things
      this.graph.bindKey(['meta+shift+z', 'ctrl+shift+z'], () => {
        if (this.graph.history.canRedo()) {
          this.graph.history.redo();
        }
        return false;
      });

      // to select all nodes
      this.graph.bindKey(['meta+a', 'ctrl+a'], () => {
        const nodes = this.graph.getNodes();
        if (nodes) {
          this.graph.select(nodes);
        }
      });
    },

    async addComponent(componentName) {
      // Generate random id to use for the new component
      const id = `V${Math.random().toString(36).substr(2, 9)}`;
      // create div element and add classname so that we can edit its outer style
      const wrap = document.createElement('div');
      wrap.classList.add('nodeEl');
      // A div element with id that we created - we will mount our new component or instance here.
      wrap.innerHTML = `<div id="${id}"></div>`;
      // Now simply add newNode and put your div element inside it - Now you have a div with the id on which we will mount our new component or instance
      const newNode = this.graph.addNode({
        shape: 'html',
        x: Math.random() * 700, // to prvent overlap - I added this to place new node at random position
        y: Math.random() * 700,
        width: 200,
        height: 70,
        html: wrap,
      });
      // As we now its listening emit event
      this.componentsOptions.forEach((obj) => {
        // Loop and store the component which we will mount on our new instance
        if (obj.name === componentName) {
          this.currentComponent = obj.component;
        }
      });

      // One edge for each component where it will be connected with main node [Although i think it will be optional]
      if (this.connected) {
        this.graph.addEdge({
          source: this.source,
          target: newNode,
        });
      }
      // create new vue instance with store and pass the id of the div element to mount our component on
      const newInstance = new Vue({
        router,
        store,
        i18n,
        render: (h) => h(this.currentComponent),
      });
      newInstance.$mount(`#${id}`);
      // now launch the dispatcher with current_selected_entity
      this.dispatchCurrentEntity();
    },

    dispatchCurrentEntity() {
      const { word } = store.state.current_selected_entity;
      const wordObj = {
        word, label: word, type: 'string', lang: 'en',
      };
      this.$store.commit('SET_CURRENT_ENTITY', wordObj);
    },

    async buildMyPage() {
      this.config = canvasConfig;
      this.config.container = this.$refs.root_node;
      this.config.width = document.getElementById('workBench').clientwidth;
      this.config.height = document.getElementById('workBench').clientheight;
      this.graph = new Graph(this.config);

      // 使用文档：https://x6.antv.vision/zh/docs/tutorial/advanced/react#%E6%B8%B2%E6%9F%93-html-%E8%8A%82%E7%82%B9
      if (this.connected) {
        this.source = this.graph.addNode({
          shape: 'html',
          x: 120,
          y: 50,
          width: 120,
          height: 50,
          html: () => {
            const wrap = document.createElement('div');
            wrap.style.width = '100%';
            wrap.style.height = '100%';
            wrap.style.display = 'flex';
            wrap.style.alignItems = 'center';
            wrap.style.justifyContent = 'center';
            wrap.style.border = '2px solid #9254de';
            wrap.style.background = '#efdbff';
            wrap.style.borderRadius = '4px';
            wrap.innerText = 'Components';
            return wrap;
          },
        });
      }
    },
  },

};
</script>

<style lang="scss" scoped>
#workBench {
  width: 100%;
  height: 100vh;
}

#branchPaint {
  width: 100%;
  height: 100%;
}
</style>
